import {defineStore} from 'pinia';

const initialState = {
    _uploads: 0,
    _unsavedChanges: false
};

function updateTitle(store){
    if (store._uploads > 0 || store._unsavedChanges){
        if (!document.title.endsWith('*'))
            document.title += '*';
    } else {
        if (document.title.endsWith('*'))
            document.title = document.title.substring(0, document.title.length - 1);
    }
}

export const useUploadStore = defineStore('upload', {
    state: () => {
        return initialState;
    },
    getters: {
        uploads: (state) => state._uploads,
        haveUnsavedChanges: (state) => state._unsavedChanges,
        anything: (state) => (state._uploads > 0 || state._unsavedChanges)
    },
    actions: {
        increaseUploads() {
            this._uploads++;
            updateTitle(this);
        },
        decreaseUploads() {
            if (this._uploads == 0)
                console.warn('decreaseUploads: already zero');
            else
                this._uploads--;
            updateTitle(this);
        },
        unsavedChanges() {
            this._unsavedChanges = true;
            updateTitle(this);
        },
        savedChanges() {
            this._unsavedChanges = false;
            updateTitle(this);
        }
    }
});


